let csrfToken = "";

export function clearSession(): void {
  csrfToken = "";
}

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const method = init?.method?.toUpperCase() || "GET";
  const publicRequest = url === "/api/install" || url === "/api/auth/login";
  const headers = new Headers(init?.headers);
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && !publicRequest) {
    if (!csrfToken) csrfToken = (await api<{ token: string }>("/api/auth/csrf")).token;
    headers.set("x-csrf-token", csrfToken);
  }
  const response = await fetch(url, { cache: "no-store", ...init, headers });
  let payload: any;
  try { payload = JSON.parse(await response.text()); }
  catch { throw new Error(response.status === 504 || response.status === 502 ? `请求等待超时 (HTTP ${response.status}), 后台任务可能仍在继续, 请查看导入进度` : `服务器返回格式异常 (HTTP ${response.status}), 请查看任务状态后重试`); }
  if (response.status === 401 && !publicRequest) {
    clearSession();
    window.dispatchEvent(new Event("hotcoin:unauthorized"));
  }
  if (!response.ok) throw new Error(payload.message || payload.error || `HTTP ${response.status}`);
  return payload as T;
}
